// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_headerContainer__mAvks, .header_headerSection__XWoJX {
    justify-content: center;
}

.header_headerContainer__mAvks {
    background-color: #495E57;
    position: relative;
}

.header_headerSection__XWoJX {
    flex-direction: column;
}

.header_headerWrapper__ZoTdx {
    align-items: center;
    text-align: center;
}

.header_headerWrapper__ZoTdx button {
    margin-bottom: 20px;
}

.header_headerSection__XWoJX {
    justify-content: space-between;
    margin: 0 auto;
}

.header_headerWrapper__ZoTdx {
    gap: 16px;
}

.header_headerWrapper__ZoTdx p {
    color: #FFF;
    font-weight: 500;
    padding-right: 20px;
    width: clamp(300px, 25vw, 440px);
}

.header_headerImage__Juyv9 {
    height: auto;
    margin: 0 auto;
    width: 70%;
}

.header_headerImage__Juyv9 img {
    width: 100%;
}

.header_headerBck__iCC1e {
    display: none;
}

@media (min-width: 951px) {
    .header_headerContainer__mAvks {
        background-color: transparent;
        display: block;
        position: relative;
    }

    .header_headerSection__XWoJX {
        flex-direction: row;
        justify-content: space-between;
        margin: 0 auto;
    }

    .header_headerWrapper__ZoTdx {
        align-items: flex-start;
        text-align: left;
    }

    .header_headerImage__Juyv9 {
        margin: 20px 0 0;
        height: 445px;
        width: 445px;
    }

    .header_headerImage__Juyv9 img {
        width: 100%;
    }

    .header_headerBck__iCC1e {
        background-color: #495E57;
        display: block;
        height: 431px;
        left: 0;
        margin: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Header/header.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,aAAa;QACb,OAAO;QACP,SAAS;QACT,kBAAkB;QAClB,MAAM;QACN,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":[".headerContainer, .headerSection {\n    justify-content: center;\n}\n\n.headerContainer {\n    background-color: #495E57;\n    position: relative;\n}\n\n.headerSection {\n    flex-direction: column;\n}\n\n.headerWrapper {\n    align-items: center;\n    text-align: center;\n}\n\n.headerWrapper button {\n    margin-bottom: 20px;\n}\n\n.headerSection {\n    justify-content: space-between;\n    margin: 0 auto;\n}\n\n.headerWrapper {\n    gap: 16px;\n}\n\n.headerWrapper p {\n    color: #FFF;\n    font-weight: 500;\n    padding-right: 20px;\n    width: clamp(300px, 25vw, 440px);\n}\n\n.headerImage {\n    height: auto;\n    margin: 0 auto;\n    width: 70%;\n}\n\n.headerImage img {\n    width: 100%;\n}\n\n.headerBck {\n    display: none;\n}\n\n@media (min-width: 951px) {\n    .headerContainer {\n        background-color: transparent;\n        display: block;\n        position: relative;\n    }\n\n    .headerSection {\n        flex-direction: row;\n        justify-content: space-between;\n        margin: 0 auto;\n    }\n\n    .headerWrapper {\n        align-items: flex-start;\n        text-align: left;\n    }\n\n    .headerImage {\n        margin: 20px 0 0;\n        height: 445px;\n        width: 445px;\n    }\n\n    .headerImage img {\n        width: 100%;\n    }\n\n    .headerBck {\n        background-color: #495E57;\n        display: block;\n        height: 431px;\n        left: 0;\n        margin: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: -1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `header_headerContainer__mAvks`,
	"headerSection": `header_headerSection__XWoJX`,
	"headerWrapper": `header_headerWrapper__ZoTdx`,
	"headerImage": `header_headerImage__Juyv9`,
	"headerBck": `header_headerBck__iCC1e`
};
export default ___CSS_LOADER_EXPORT___;
